import {Component, Input} from '@angular/core';
import {AlertNotificationViewData} from '../../../../shared/store/alerts/alerts';

@Component({
  selector: 'app-smart-alert-badge-real-conversions',
  templateUrl: './smart-alert-badge-real-conversions.component.html',
  styleUrls: ['./smart-alert-badge-real-conversions.component.scss']
})
export class SmartAlertBadgeRealConversionsComponent {
  @Input() public notification: AlertNotificationViewData;
}
